(function () {
    if (!customElements.get('product-accordion-new')) {
        class ProductAccordionNew extends HTMLElement {
            static selectors = {
                item: '.js-product-accordion-item',
                control: '.js-product-accordion-control',
                content: '.js-product-accordion-content',
                contentInner: '.js-product-accordion-content-inner'
            };

            static classes = {
                isOpen: 'is-open'
            };

            connectedCallback() {
                this.items = [];
                this._closeHandler = (e) => {
                    if (e.detail.source !== this) {
                        this.items.forEach((item) => this.close(item));
                    }
                };
                document.addEventListener('accordion-new:open', this._closeHandler);
                this.init();
            }

            disconnectedCallback() {
                this.items.forEach((item) => clearTimeout(item.timeout));
                document.removeEventListener('accordion-new:open', this._closeHandler);
            }

            init() {
                const itemElements = this.querySelectorAll(ProductAccordionNew.selectors.item);
                if (!itemElements.length) return;

                itemElements.forEach((element) => this.setupItem(element));
            }

            setupItem(element) {
                const index = Number.parseInt(element.dataset.itemIndex);
                const control = element.querySelector(ProductAccordionNew.selectors.control);
                const content = element.querySelector(ProductAccordionNew.selectors.content);
                const contentInner = element.querySelector(ProductAccordionNew.selectors.contentInner);

                if (!control || !content || !contentInner) return;

                const itemData = {
                    element,
                    control,
                    content,
                    contentInner,
                    index,
                    isOpen: element.classList.contains(ProductAccordionNew.classes.isOpen),
                    timeout: null
                };

                this.items.push(itemData);

                control.addEventListener('click', () => this.handleToggleClick(itemData));
            }

            handleToggleClick(item) {
                const shouldClose = item.isOpen;
                this.items.forEach((otherItem) => {
                    if (otherItem === item) {
                        shouldClose ? this.close(otherItem) : this.open(otherItem);
                    } else {
                        this.close(otherItem);
                    }
                });
            }

            open(item) {
                if (item.isOpen) return;

                document.dispatchEvent(new CustomEvent('accordion-new:open', { detail: { source: this } }));
                clearTimeout(item.timeout);
                item.isOpen = true;
                item.element.classList.add(ProductAccordionNew.classes.isOpen);
                item.content.style.height = `${item.contentInner.offsetHeight}px`;

                item.timeout = setTimeout(() => {
                    item.content.style.height = 'auto';
                }, 400);
            }

            close(item) {
                if (!item.isOpen) return;

                clearTimeout(item.timeout);
                item.isOpen = false;
                item.element.classList.remove(ProductAccordionNew.classes.isOpen);
                item.content.style.height = `${item.contentInner.offsetHeight}px`;

                item.timeout = setTimeout(() => {
                    item.content.style.height = '0';
                }, 0);
            }
        }

        customElements.define('product-accordion-new', ProductAccordionNew);
    }
})();
